import { FiltersOperator } from "src/app/widgets/filters/api/filters-operator.api";
import { BookmarkElement } from "../../models/bookmark-element.model";
import { BookmarkElementsOperator } from "./bookmark-elements.operator";
import { OverviewFilterInput } from "src/app/pages/stock/stock.service";
import { Bookmark } from "../../models/bookmark.model";
import { isFunction } from "src/app/helpers/type-utils";

/**
 *
 */
export class FiltersGroupBookmarkElementsOperator extends BookmarkElementsOperator {

	public filtersOperator: FiltersOperator | (() => FiltersOperator);

	public override applyBookmarkElements(bookmarkElements: BookmarkElement[]): void {
		const filtersOperator: FiltersOperator = isFunction(this.filtersOperator) ? this.filtersOperator() : this.filtersOperator;

		for (let a = 0; a < filtersOperator.overviewFiltersInputs.length; a++) {
			const filter: OverviewFilterInput = filtersOperator.overviewFiltersInputs[a];

			const elements: BookmarkElement[] = bookmarkElements.filter((element) => element.key === filter.selectionName);

			filter.selectedValues = elements.map((element) => element.value);
		}

		filtersOperator.applyFilters();
	}

	public override prepareBookmarkElements(bookmark: Bookmark): BookmarkElement[] {
		const filtersOperator: FiltersOperator = isFunction(this.filtersOperator) ? this.filtersOperator() : this.filtersOperator;

		const elements: BookmarkElement[] = [];

		for (let a = 0; a < filtersOperator.overviewFiltersInputs.length; a++) {
			const filter: OverviewFilterInput = filtersOperator.overviewFiltersInputs[a];

			for (let b = 0; b < filter.selectedValues.length; b++) {
				const value = filter.selectedValues[b];

				elements.push(
					new BookmarkElement(
						undefined,
						bookmark.bookmarkId,
						filter.selectionName,
						value,
						this.id
					)
				);
			}
		}

		return elements;
	}

	public static readonly DEFAULT_ID_PART: number = 1;

	/**
	 *
	 * @param id Responsible for identifying multiple `BookmarkElement`s that this operator controls.
	 * Used to differentiate between operators in the same bookmarks group.
	 * For example if we had one bookmark group controlling multiple filters then those filters operators would have different ids to see which elements belong to which operator.
	 * Each operator should have a unique id in a group (not on page).
	 */
	constructor(
		options: {
			id: string,
			filtersOperator: FiltersOperator | (() => FiltersOperator),
			onAllBookmarkElementsApplied?: () => void,
		}
	) {
		super(options.id, options.onAllBookmarkElementsApplied);

		this.filtersOperator = options.filtersOperator;
	}
}
